import { Button, Col, Popconfirm, Row, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import styled from 'styled-components';
import { BidPackage } from '../../modules/bid-packages';
import { BidderStatus } from '../../modules/bidders';
import { styledTable } from '../styled/mixin';
import Title from 'antd/lib/typography/Title';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface BidPackageListComponentProps {
  bidPackages: BidPackage[];
  isBudgeting: boolean;
  moveToBidPackageCreatePage: () => void;
  moveToBidPackageDetailPage: (bidPackageId: number) => void;
  onDelete: (bidPackage: BidPackage) => void;
}

function BidPackageListComponent({
  bidPackages,
  isBudgeting,
  moveToBidPackageCreatePage,
  moveToBidPackageDetailPage,
  onDelete,
}: BidPackageListComponentProps) {
  const columns: ColumnsType<BidPackage> = [
    // {
    //   title: '담당자',
    //   dataIndex: 'lead',
    // },
    {
      title: '이름',
      dataIndex: 'name',
      render: (text: any, record: any) => (
        <span
          className="clickable-table-item"
          onClick={() => moveToBidPackageDetailPage(record.id)}
        >
          {text}
        </span>
      ),
    },
    {
      title: '메일발송',
      dataIndex: 'isPublished',
      render: (text: any, record: BidPackage) =>
        record.isPublished ? '예' : '아니오',
    },
    {
      title: '모든업체',
      dataIndex: 'bidderCount',
      render: (text: any, record: BidPackage) => record.bidders.length,
    },
    {
      title: '수락업체',
      dataIndex: 'acceptedBidderCount',
      render: (text: any, record: BidPackage) =>
        record.bidders.filter((item) => item.status === BidderStatus.ACCEPTED)
          .length,
    },
    {
      title: '거절업체',
      dataIndex: 'declinedBidderCount',
      render: (text: any, record: BidPackage) =>
        record.bidders.filter((item) => item.status === BidderStatus.DECLINED)
          .length,
    },
    {
      title: '제출업체',
      dataIndex: 'submittedBidderCount',
      render: (text: any, record: BidPackage) =>
        record.bidders.filter((item) => item.status === BidderStatus.SUBMITTED)
          .length,
    },
    {
      title: '재요청업체',
      dataIndex: 'requestProposalAgainBidderCount',
      render: (text: any, record: BidPackage) =>
        record.bidders.filter((item) => item.status === BidderStatus.RECONFIRM)
          .length,
    },
    {
      title: '낙찰업체',
      dataIndex: 'awardedBidderCount',
      render: (text: any, record: BidPackage) =>
        record.bidders.filter((item) => item.status === BidderStatus.AWARDED)
          .length,
    },
    // {
    //   title: '미선정업체',
    //   dataIndex: 'notAwardedBidderCount',
    //   render: (text: any, record: BidPackage) =>
    //     record.bidders.filter(
    //       (item) => item.status === BidderStatus.NOT_AWARDED,
    //     ).length,
    // },
    {
      title: '마감일',
      dataIndex: 'bidDueDateTime',
      render: (text: any, record: BidPackage) =>
        moment(record.bidDueDateTime).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      render: (text, record, index) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              onConfirm={() => onDelete(record)}
            >
              <Button size="small" className="delete-table-list-item">
                삭제
              </Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={3}>외주/자재 {isBudgeting ? '견적' : '입찰'}</Title>
        </Col>
        <Col>
          <Button onClick={moveToBidPackageCreatePage}>등록</Button>
        </Col>
      </Row>

      {bidPackages && (
        <Table<BidPackage>
          rowKey="id"
          columns={columns}
          dataSource={bidPackages}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}

export default BidPackageListComponent;
